import { Record } from "immutable";

export type ParentFromServerType = {
  userId: string;
  code: string;
  familyName: string;
  givenName: string;
  email?: string;
};

export type ParentType = {
  id: string | null;
  code: string | null;
};

const defaultParent: ParentType = {
  id: null,
  code: null
};

export default class Parent extends Record(defaultParent) {}
